import { CacheProvider } from '@emotion/react';
import PhonelinkEraseRounded from '@mui/icons-material/PhonelinkEraseRounded';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useEffect } from 'react';
import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { emotionCache } from '../../utils/emotionCache';
import { GenericError } from './GenericError';
import { iconStyle } from './styled';

/**
 * RootErrorElement handles errors that bubble to the top of our router. It will handle the "Page Does Not Exist"
 * error which always bubbles to the top. All other errors will be treated as a general error.
 * In practice, most errors should be handled by ErrorElement which is declared further down our router configuration. 
 */
export const RootErrorElement = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if the pathname contains '.aspx'
  useEffect(() => {
    if (location.pathname.includes('.aspx')) {
      navigate('/');
    }
  }, [location.pathname, navigate]);

  console.error(error);
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <CacheProvider value={emotionCache}>
      <GenericError
        icon={<SearchOffIcon sx={iconStyle} />}
        header={"Page does not exist!"}
        button={"Go to Home Page"}
        onButton={() => navigate("/")}
      />
    </CacheProvider>
  }
  return <GenericError
    icon={<PhonelinkEraseRounded sx={iconStyle} />}
    header={"Error loading the page!"}
    subText={"Please try again"}
    button={"Retry"}
    onButton={() => navigate(0)}
  />
};